<div class="grid">
	<div class="col-12">
		<div class="card">
			<h5>Historial de notificaciones</h5>
			<p-table
				#dt1
				[value]="notifications"
				dataKey="id"
				[rows]="10"
				[loading]="loading"
				[rowHover]="true"
				[paginator]="true"
				[globalFilterFields]="[
					'id', 'title', 'message'
				]"
				responsiveLayout="scroll"
			>
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<button
							pButton
							label="Limpiar"
							class="p-button-rounded mb-2"
							(click)="clear(dt1)"
						></button>
						<span class="p-input-icon-left">
							<i class="pi pi-circle-fill"></i>
							<input
								pInputText
								type="text"
								#filter
								(input)="dt1.filterGlobal($event.target.value, 'contains')"
								placeholder="Buscar"
								class="w-full"
							/>
						</span>
						<div class="text-right">
							<button
								pButton
								pRipple
								label="Actualizar"
								pTooltip="Actualizar listado de usuarios"
								type="button"
								icon="pi pi-refresh"
								class="p-button-raised p-button-outlined m-1"
								(click)="loadNotificationHistory(); clear(dt1)"
							></button>
						</div>
					</div>
				</ng-template>

				<ng-template pTemplate="header">
					<!-- HEADERS -->
					<tr>
						<th class="text-center" pSortableColumn="id">
							<p-sortIcon field="id"></p-sortIcon>
							ID
						</th>
						<th class="text-center" pSortableColumn="title">
							<p-sortIcon field="title"></p-sortIcon>
							Título
						</th>
						<th class="text-center" pSortableColumn="message">
							<p-sortIcon field="message"></p-sortIcon>
							Mensaje
						</th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-notification>
					<tr>
						<td class="text-center" style="min-width: 5rem">
							{{ notification.id }}
						</td>
						<td class="text-center" style="min-width: 5rem">
							{{ notification.title }}
						</td>
						<td class="text-center" style="min-width: 5rem">
							{{ notification.message }}
						</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Sin resultados</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Cargando notificaciones...</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>